namespace $.$$ {

	export class $eve_checkbox_group_labelled extends $.$eve_checkbox_group_labelled {}

}
